import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFetchGoImg } from '@src/containers/Session/hooks/useFetchGoImg';
import { cachedImages } from '@src/containers/Cache/selectors';

import MediaBigManage from '..';

const MediaBigManageCLoader = (props) => {
	const {
		isWatchLoading,
		neighbours,
		targetImgTail = '=w1500-h1000-l95-e31', // According to MediaBigPhoto tail
		media,
		...rest
	} = props;

	const [loaded, setLoaded] = React.useState([]);
	const [mediaLoading, setMediaLoading] = React.useState(true);

	const { fetchGoImg } = useFetchGoImg();
	const imagesCache = useSelector(cachedImages);

	const cachedMedia = useMemo(() => {
		let cached;

		if (typeof media.img?.src !== 'number') {
			cached = media;
		} else {
			const existMedia = imagesCache[media.img?.src];
			cached = existMedia ? { img: existMedia } : media;
		}

		if (cached.img?.isVideo) {
			return {
				video: {
					...cached.img,
					src: cached.img.videoLink || cached.img.src,
				},
			};
		}

		return { ...cached };
	}, [media, imagesCache]);

	const preloadImage = useCallback(
		async (url) => {
			let src = url;
			if (typeof src === 'number') {
				setLoaded((curr) => {
					return [...curr, src];
				});
				try {
					const r = await fetchGoImg({ src }).unwrap();
					src = r.src;
				} catch (err) {
					// eslint-disable-next-line no-console
					console.error(err);
				}
			}

			const img = new global.Image();
			img.onload = () => {
				setLoaded((curr) => {
					return [...curr, src];
				});
			};
			img.src = src;
		},
		[fetchGoImg],
	);

	useEffect(() => {
		neighbours.forEach((i) => {
			const targetSrc = imagesCache[i.src]?.src || i.src;
			const checkSrc =
				typeof targetSrc === 'number'
					? targetSrc
					: `${targetSrc}${targetImgTail}`;

			if (!loaded.includes(checkSrc) && checkSrc !== media?.img?.src) {
				preloadImage(checkSrc);
			}
		});
	}, [loaded, neighbours, media, preloadImage, targetImgTail, imagesCache]);

	const handleLoad = React.useCallback(() => {
		setMediaLoading(false);
	}, []);

	const handleLoadStart = useCallback(() => {
		setMediaLoading(true);
	}, []);

	const isLoading = isWatchLoading ? mediaLoading : !media;

	return (
		<MediaBigManage
			isLoading={isLoading && !cachedMedia.video}
			onLoad={handleLoad}
			onLoadStart={handleLoadStart}
			media={cachedMedia}
			{...rest}
		/>
	);
};

MediaBigManageCLoader.propTypes = {
	...MediaBigManage.propTypes,
};

export default MediaBigManageCLoader;
